import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    createStaffMember: {
        method: 'POST',
        url: `${BASE_PATH_API}/staffMembers`
    },
    getStaffMember: {
        method: 'GET',
        url: `${BASE_PATH_API}/staffMembers/:id`
    },
    updateStaffMemberName: {
        method: 'PUT',
        url: `${BASE_PATH_API}/staffMembers/:id/name`
    },
    updateStaffMemberContactDetails: {
        method: 'PUT',
        url: `${BASE_PATH_API}/staffMembers/:id/contact`
    },
    toggleStaffMemberAccountStatus: {
        method: 'PUT',
        url: `${BASE_PATH_API}/staffMembers/:id/status`
    },
    deleteStaffMember: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/staffMembers/:id`
    }
};

export function StaffMemberApi() {
    return createActions(actions);
}
